/// <reference types="./updateRenameTypes.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ok } from '@dossierhq/core';
import { buildSqliteSqlQuery } from '@dossierhq/database-adapter';
import { queryRun } from '../QueryFunctions.js';
export async function schemaUpdateRenameTypes(database, context, entityTypes, componentTypes) {
    for (const [oldName, newName] of Object.entries(entityTypes)) {
        const result = await queryRun(database, context, buildSqliteSqlQuery(({ sql }) => {
            sql `UPDATE entities SET type = ${newName} WHERE type = ${oldName}`;
        }));
        if (result.isError())
            return result;
    }
    for (const [oldName, newName] of Object.entries(componentTypes)) {
        const latestResult = await queryRun(database, context, buildSqliteSqlQuery(({ sql }) => {
            sql `UPDATE entity_latest_value_types SET value_type = ${newName} WHERE value_type = ${oldName}`;
        }));
        if (latestResult.isError())
            return latestResult;
        const publishedResult = await queryRun(database, context, buildSqliteSqlQuery(({ sql }) => {
            sql `UPDATE entity_published_value_types SET value_type = ${newName} WHERE value_type = ${oldName}`;
        }));
        if (publishedResult.isError())
            return publishedResult;
    }
    return ok(undefined);
}
//# sourceMappingURL=updateRenameTypes.js.map